import { render, staticRenderFns } from "./MelonTVSchedule.vue?vue&type=template&id=9d46c2c0&"
import script from "./MelonTVSchedule.vue?vue&type=script&lang=js&"
export * from "./MelonTVSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports